import script from "./MiniPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./MiniPlayer.vue?vue&type=style&index=0&id=53e60245&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e60245"]])

export default __exports__